
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');

const WOW = require('wowjs');
window.wow = new WOW.WOW({
    live: false
});

require('./components/bootstrap');
require('./fieldgroups');

Vue.component('favorite', require('./components/Favorite.vue'));

Spark.forms.register = {
	first_name: '',
	last_name: '',
    audience: ''
};

var app = new Vue({
    mixins: [require('spark')]
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js